import { render, staticRenderFns } from "./TransferInfo.vue?vue&type=template&id=31e0eb84&scoped=true"
import script from "./TransferInfo.vue?vue&type=script&lang=js"
export * from "./TransferInfo.vue?vue&type=script&lang=js"
import style0 from "./TransferInfo.vue?vue&type=style&index=0&id=31e0eb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0eb84",
  null
  
)

export default component.exports